/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type TimeRegistrationModalCreate_QueryVariables = {
    taskId?: string | null | undefined;
    companyTaskId?: string | null | undefined;
    companyProjectId?: string | null | undefined;
    personId?: string | null | undefined;
};
export type TimeRegistrationModalCreate_QueryResponse = {
    readonly viewer: {
        readonly actualPersonId: string | null;
        readonly component: string | null;
        readonly " $fragmentRefs": FragmentRefs<"TimeRegistrationModalCreate_viewer">;
    } | null;
};
export type TimeRegistrationModalCreate_Query = {
    readonly response: TimeRegistrationModalCreate_QueryResponse;
    readonly variables: TimeRegistrationModalCreate_QueryVariables;
};



/*
query TimeRegistrationModalCreate_Query(
  $taskId: ID
  $companyTaskId: String
  $companyProjectId: String
  $personId: ID
) {
  viewer {
    actualPersonId
    component(name: "time_registration_modal_create")
    ...TimeRegistrationModalCreate_viewer_AkUXH
    id
  }
}

fragment TimeRegistrationModalCreate_viewer_AkUXH on Viewer {
  actualPersonId
  task(id: $taskId, companyTaskId: $companyTaskId) {
    id
    project {
      id
    }
  }
  project(id: $companyProjectId) {
    id
  }
  company {
    person(id: $personId) {
      fullName
      id
    }
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "taskId",
    "type": "ID"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "companyTaskId",
    "type": "String"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "companyProjectId",
    "type": "String"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "personId",
    "type": "ID"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "time_registration_modal_create"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"time_registration_modal_create\")"
},
v3 = {
  "kind": "Variable",
  "name": "companyTaskId",
  "variableName": "companyTaskId"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = [
  (v4/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TimeRegistrationModalCreate_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "args": [
              {
                "kind": "Variable",
                "name": "companyProjectId",
                "variableName": "companyProjectId"
              },
              (v3/*: any*/),
              {
                "kind": "Variable",
                "name": "personId",
                "variableName": "personId"
              },
              {
                "kind": "Variable",
                "name": "taskId",
                "variableName": "taskId"
              }
            ],
            "kind": "FragmentSpread",
            "name": "TimeRegistrationModalCreate_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TimeRegistrationModalCreate_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": [
              (v3/*: any*/),
              {
                "kind": "Variable",
                "name": "id",
                "variableName": "taskId"
              }
            ],
            "concreteType": "Task",
            "kind": "LinkedField",
            "name": "task",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ProjectType",
                "kind": "LinkedField",
                "name": "project",
                "plural": false,
                "selections": (v5/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "id",
                "variableName": "companyProjectId"
              }
            ],
            "concreteType": "ProjectType",
            "kind": "LinkedField",
            "name": "project",
            "plural": false,
            "selections": (v5/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "personId"
                  }
                ],
                "concreteType": "Person",
                "kind": "LinkedField",
                "name": "person",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "fullName",
                    "storageKey": null
                  },
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          (v4/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "TimeRegistrationModalCreate_Query",
    "operationKind": "query",
    "text": "query TimeRegistrationModalCreate_Query(\n  $taskId: ID\n  $companyTaskId: String\n  $companyProjectId: String\n  $personId: ID\n) {\n  viewer {\n    actualPersonId\n    component(name: \"time_registration_modal_create\")\n    ...TimeRegistrationModalCreate_viewer_AkUXH\n    id\n  }\n}\n\nfragment TimeRegistrationModalCreate_viewer_AkUXH on Viewer {\n  actualPersonId\n  task(id: $taskId, companyTaskId: $companyTaskId) {\n    id\n    project {\n      id\n    }\n  }\n  project(id: $companyProjectId) {\n    id\n  }\n  company {\n    person(id: $personId) {\n      fullName\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();
(node as any).hash = '040cd76ee7244696dd0b40db52121f79';
export default node;
